import axios from "axios";
import router from "../router";
import { useShopStore } from "@/store/shop";
import { useAppStore } from "@/store/app";
import { useAuthStore } from "../store/auth";

const ACCESS_TOKEN = "app_access_token";
const REFRESH_TOKEN = "app_refresh_token";

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL || "/",
});

axiosInstance.interceptors.request.use(
    (config) => {
        const appStore = useAppStore();
        const shopStore = useShopStore();

        // Do something before request is sent
        config.headers.Authorization = `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`;
        config.headers["referer-url"] = window.location.href;
        config.headers["uuid"] = appStore.uuid;
        config.headers["component"] = router.currentRoute.value.path === "/" ? "Home" : router.currentRoute.value.name;

        if (shopStore.selectedShop?.id !== undefined) {
            config.headers["shopId"] = shopStore.selectedShop.id;
        } else if (shopStore.selectedShopId !== null) {
            config.headers["shopId"] = shopStore.selectedShopId;
        } else {
            config.headers["shopId"] = 0;
        }

        return config;
    },
    (error) => {
        // Do something with request error
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    (response) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        return response;
    },
    async (error) => {
        if (error.message !== "canceled") {
            // Any status codes that falls outside the range of 2xx cause this function to trigger
            // Do something with response error
            const authStore = useAuthStore();

            if (error.response.status === 403) {
                localStorage.removeItem(ACCESS_TOKEN);
                localStorage.removeItem(REFRESH_TOKEN);
                router.push({ name: "Home" });
            }

            // error.response.status === 401 && error.response.data.message === "Unauthenticated."

            if (error.response.status === 401) {
                if (!localStorage.getItem(REFRESH_TOKEN)) {
                    const originalRequest = error.config;
                    const token = await authStore.refreshToken({ refreshToken: localStorage.getItem(REFRESH_TOKEN) });
                    originalRequest.headers.Authorization = `Bearer ${token.data.access_token}`;
                    return axiosInstance(originalRequest);
                } else {
                    authStore.logout();
                }
            }

            // if (error.response.status === 401 && error.response.data.message === "The refresh token is invalid.") {
            //     authStore.logout();
            // }

            return Promise.reject(error);
        }
    }
);

export default axiosInstance;
